module.exports = {"client":"Client Info & Contact","number":"Amount of Customer","name":"Customer Name","last_name":"Last Name","ticket_number":"Ticket No.","majorContact":"Major Contact","birthday":"Birthday","phone":"Phone","gender":"Gender","male":"Male","female":"Female","unknown":"Unknown","other_contact_method":"Other Contact","email":"Email","other_contact_number":"Account","zipcode":"Zip Code"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/grouptour/create/client.json
// module id = 62D8
// module chunks = 58